<template>
    <v-form class="mt-5 mb-5">
        <v-container v-if="user != null">
            <v-row>
                <v-col cols="12" sm="3">
                    <v-text-field
                            class="requireField"
                            v-model="user.lawyer_title"
                            :label="' * ' + language.lang('Full Name')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field class="requireField"
                                  v-model="user.username"
                                  :label="' * ' + language.lang('Change Username')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.password"
                            :label="language.lang('Change Password')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.lawyer_email"
                            :label="language.lang('Email Address')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.lawyer_phone"
                            :label="language.lang('Phone Number')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.lawyer_brief"
                            :label="language.lang('#RCIC')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            persistent-hint
                            hint="https://www.facebook.com/zuck"
                            v-model="user.lawyer_contact_public.facebook"
                            :label="language.lang('Facebook Page')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            persistent-hint
                            hint="https://www.instagram.com/zuck"
                            v-model="user.lawyer_contact_public.instagram"
                            :label="language.lang('Instagram Page')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            persistent-hint
                            hint="https://twitter.com/jack"
                            v-model="user.lawyer_contact_public.twitter"
                            :label="language.lang('Twitter Page')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            persistent-hint
                            hint="https://www.youtube.com/c/LawCrimeNetwork"
                            v-model="user.lawyer_contact_public.youtube"
                            :label="language.lang('Youtube Page')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            persistent-hint
                            hint="user#1234"
                            v-model="user.lawyer_contact_private.discord"
                            :label="language.lang('Discord Account')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            persistent-hint
                            hint="https://t.me/username"
                            v-model="user.lawyer_contact_private.telegram"
                            :label="language.lang('Telegram Account')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            persistent-hint
                            hint="live:0123456789"
                            v-model="user.lawyer_contact_private.skype"
                            :label="language.lang('Skype Account')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            persistent-hint
                            hint="12345678900"
                            v-model="user.lawyer_contact_private.whatsapp"
                            :label="language.lang('Whatsapp Account')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.lawyer_company"
                            :label="language.lang('Company Name')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                            v-model="user.lawyer_init_fee"
                            persistent-hint
                            :hint="language.lang('In Dollars')"
                            :label="language.lang('Initial Consultation Fee')"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4">
                    <v-select :items="services" multiple
                              item-text="abbr"
                              item-value="state"
                              v-model="user.lawyer_services"
                              :label="language.lang('Special Service')"
                              :hint="language.lang('Choose your special services')"
                              persistent-hint>

                    </v-select>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-select :items="languages" multiple
                              v-model="user.lawyer_languages"
                              :label="language.lang('Languages')"
                              :hint="language.lang('Choose your languages')"
                              persistent-hint>

                    </v-select>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-select :items="specializations" multiple
                              item-text="abbr"
                              item-value="state"
                              v-model="user.lawyer_specializations"
                              :label="language.lang('Specializations')"
                              :hint="language.lang('Choose your specializations')"
                              persistent-hint>

                    </v-select>
                </v-col>
            </v-row>
            <v-row>
<!--                <v-col cols="12" sm="4">-->
<!--                    <v-textarea-->
<!--                            v-model="user.lawyer_description"-->
<!--                            :label="language.lang('About Me')"-->
<!--                    ></v-textarea>-->
<!--                </v-col>-->
                <!--                <v-col cols="12" sm="4">-->
                <!--                    <v-textarea-->
                <!--                            v-model="user.lawyer_location_canada"-->
                <!--                            :label="language.lang('Canada Location')"-->
                <!--                    ></v-textarea>-->
                <!--                </v-col>-->
                <!--                <v-col cols="12" sm="4">-->
                <!--                    <v-textarea-->
                <!--                            v-model="user.lawyer_location_iran"-->
                <!--                            :label="language.lang('Iran Location')"-->
                <!--                    ></v-textarea>-->
                <!--                </v-col>-->
            </v-row>
            <div :class="!isEN ? 'text-left' : 'text-right'">
                <base-button tag="span" @click="editProfile"
                             type="default" class="m-1 mt-4">
                    {{language.lang('Set Profile')}}
                </base-button>
                <base-button tag="span" @click="fetchUser"
                             type="secondary" class="m-1 mt-4">
                    {{language.lang('Discard')}}
                </base-button>
            </div>
        </v-container>
    </v-form>
</template>
<script>
    import language from "@/utils/language";
    import oracle from "@/utils/oracle";

    export default {
        data() {
            return {
                language: language,
                oracle: oracle,
                isEN: oracle.isEN(),
                user: null,
                languages: ['فارسی', 'English', 'Français', 'हिन्दी', '中国人', 'pilipino', 'Türkçe'],
                specializations: [
                    {state: 'Investment and Business Visas', abbr: language.lang('Investment and Business Visas')},
                    {state: 'Work Visas', abbr: language.lang('Work Visas')},
                    {state: 'Express Entry', abbr: language.lang('Express Entry')},
                    {state: 'Visitor & Tourism Visas', abbr: language.lang('Visitor & Tourism Visas')},
                    {state: 'PNP', abbr: language.lang('PNP')},
                    {state: 'Family & sponsorship Visas', abbr: language.lang('Family & sponsorship Visas')},
                    {state: 'Study & Training Visas', abbr: language.lang('Study & Training Visas')},
                ],
                services: [
                    {state: 'Free Consultation', abbr: language.lang('Free Consultation')},
                    {state: 'Fast Reply', abbr: language.lang('Fast Reply')},
                    {state: 'Insured', abbr: language.lang('Professional Insurance')}
                ]
            };
        },
        methods: {
            editProfile() {
                const model = {
                    "password": this.user.password != null && this.user.password.length > 0 ? oracle.MD5(this.user.password) : null,
                    "username": this.user.username,
                    "lawyer_contact_public": this.user.lawyer_contact_public,
                    "lawyer_contact_private": this.user.lawyer_contact_private,
                    "lawyer_email": this.user.lawyer_email,
                    "lawyer_phone": this.user.lawyer_phone,
                    "lawyer_brief": this.user.lawyer_brief,
                    "lawyer_init_fee": this.user.lawyer_init_fee,
                    "lawyer_location_iran": this.user.lawyer_location_iran,
                    "lawyer_location_canada": this.user.lawyer_location_canada,
                    "lawyer_company": this.user.lawyer_company,
                    "lawyer_title": this.user.lawyer_title,
                    "lawyer_specializations": this.user.lawyer_specializations,
                    "lawyer_languages": this.user.lawyer_languages,
                    "lawyer_services": this.user.lawyer_services,
                };
                oracle.axios("lawyer/edit", model, (res) => {
                    oracle.showMessage(res.message, null, null, 'checked');
                });
            }, fetchUser() {
                oracle.axios("lawyer/getProfile", {}, (res) => {
                    if (res.data.lawyer_contact_public == null) {
                        res.data.lawyer_contact_public = {
                            "facebook": "",
                            "twitter": "",
                            "instagram": "",
                            "youtube": ""
                        };
                    }
                    if (res.data.lawyer_contact_private == null) {
                        res.data.lawyer_contact_private = {
                            "skype": "",
                            "telegram": "",
                            "whatsapp": "",
                            "discord": ""
                        };
                    }
                    this.user = res.data;
                });
            }
        },
        mounted() {
            this.fetchUser()
        },
    };
</script>
<style>
    .requireField .v-label {
        color: red !important;
    }
</style>
